// extracted by mini-css-extract-plugin
export var logo = "_ih-2";
export var logoWrapper = "_ih-1";
export var strip = "_ih-0";